import { useQuery } from '@tanstack/react-query';
import Api from '../api/Api';
import { IPreprocessedAnalyticsPayload } from '../types/chart';
import { QUERY_KEYS } from './queryKeys';

export const useGetPreprocessedAnalyticsQuery = (
  payload: IPreprocessedAnalyticsPayload,
  isEnabled: boolean,
  coordinates: number[]
) => {
  return useQuery({
    queryKey: [
      QUERY_KEYS.analytics.preprocessedAnalytics,
      payload.DatasetId,
      coordinates,
    ],
    queryFn: async (): Promise<any[]> => {
      const result = await Api.chart.getPreprocessedAnalytics(payload);
      return result.Result;
    },
    enabled: !!payload.DatasetId && isEnabled,
  });
};
